import { render } from "./DatasetTable.vue?vue&type=template&id=95cad394&scoped=true&ts=true"
import script from "./DatasetTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetTable.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetTable.vue?vue&type=style&index=0&id=95cad394&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cad394"],['__file',"resources/js/core/report/components/DatasetTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95cad394"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95cad394', __exports__)) {
    console.log('reload')
    api.reload('95cad394', __exports__)
  }
  
  module.hot.accept("./DatasetTable.vue?vue&type=template&id=95cad394&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('95cad394', render)
  })

}


export default __exports__